// Canonical 11-pharmacy roster. Mirrors db/schema.sql seed and the auto-memory reference.
// Both frontend and backend import this so the list stays in one place.

export type Store = {
  storeId: number;
  code: string;     // PK Software export prefix (filename code)
  city: string;
  npi: string;
};

export const STORES: Store[] = [
  { storeId:  9, code: "COR",  city: "Corinth",         npi: "1609403716" },
  { storeId:  7, code: "DEN",  city: "Denton",          npi: "1679515977" },
  { storeId:  2, code: "ER",   city: "Erie",            npi: "1629297718" },
  { storeId:  8, code: "FM",   city: "Flower Mound",    npi: "1043253206" },
  { storeId:  1, code: "GV",   city: "Greenville",      npi: "1982919874" },
  { storeId:  3, code: "HST",  city: "Houston",         npi: "1245386689" },
  { storeId:  5, code: "JMST", city: "Jamestown",       npi: "1295875730" },
  { storeId: 10, code: "CPL",  city: "Lancaster",       npi: "1487857207" },
  { storeId:  4, code: "SEM",  city: "Seminole, FL",    npi: "1972500130" },
  { storeId: 11, code: "TUC",  city: "Tucson",          npi: "1174691810" },
  { storeId:  6, code: "VB",   city: "Virginia Beach",  npi: "1700894649" },
];
